module.exports = __webpack_public_path__ + "static/CreatedShop-0c719f216e2e90e1499d21832c65825c.png";